import proxyClient from '@/client/proxyClient'
import defaultClient from '@/client/fundaNowClient'
import qs from 'query-string'

const PREFIX = 'loans-request'

export default {
  postLoansRequest(body) {
    return proxyClient.post(`/${PREFIX}`, body)
  },
  putLoansRequest(uuid, body) {
    return proxyClient.put(`/${PREFIX}/${uuid}`, body)
  },

  getLoansRequests(query) {
    return proxyClient.get(`/${PREFIX}?${qs.stringify(query)}`)
  },

  getLoansRequestDetail(uuid) {
    return proxyClient.get(`/${PREFIX}/${uuid}`)
  },

  getLoansRequestLoan(uuid) {
    return proxyClient.get(`/${PREFIX}/${uuid}/loan`)
  },

  cancelLoansRequest(uuid) {
    return proxyClient.put(`/${PREFIX}/${uuid}/cancel`)
  },

  getLoansRequestFiles(uuid) {
    return proxyClient.get(`/${PREFIX}/${uuid}/files`)
  },

  postLoansRequestFile(uuid, file, title, filename) {
    const formData = new FormData()
    if (filename) {
      formData.append('file', file, filename)
    } else {
      formData.append('file', file)
    }

    if (title) {
      formData.append('title', title)
    }

    return defaultClient.post(`/loans/requests/${uuid}/upload-file/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },

  deleteLoansRequestFile(uuid) {
    return defaultClient.delete(`/loans/request-files/${uuid}`)
  },
}
